<mydocma-mm-app-pane-header [text]="headerText$ | async" class="pane-header"
                            (doneClick)="onDoneClick()" (closeClick)="faultActionsService.onClose()"
                            [doneEnabled]="!((rightPaneService.saving$ | async) && !((plansManagerService.selectedPlan$ | async) == null))"
                            [doneVisible]="(!(appContainerService.mobileView$ | async) && !isPaneUndocked )"
                            [closeEnabled]="!(rightPaneService.saving$ | async)"
                            [changed]="((changeService.changesPerMask.get(faultRightPane) | async) || (changeService.changesPerMask.get(planRightPane) | async))
  && !(((plansManagerService.selectedPlan$ | async) == null) && planEditService.planEditMode === 3)"
                            [locked]="isLocked">


  <div ap-pane-menu>
    <button mat-icon-button

            [matMenuTriggerFor]="menu"
            #parentMenuTrigger="matMenuTrigger"
            *ngIf="fault && fault.changeState?.status !== changeStatus.New;">
      <mat-icon>more_horiz</mat-icon>
    </button>

    <mat-menu #menu="matMenu">

      <button mat-menu-item
              *ngIf="(permissionService.hasShortcuts$ | async) && (permissionService.shortcuts$ | async).length > 0 && (permissionService.permissionNewActivity$ | async) === true"
              [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity"
              [matMenuTriggerFor]="shortcutMenu"
              (onMenuOpen)="onShortCutMenuOpen()"
              (onMenuClose)="shortCutMenuOpenState = false"
              (click)="onShortCutMenuClick($event)"
              #matMenuShortcutsTrigger="matMenuTrigger"
              [disabled]="(faultsState$ | async).IsAnyFaultLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity">
        <mydocma-custom-mat-icon
          matTooltip="{{'MM.general.button.newActivity' | translate }} {{(faultsState$ | async).IsAnyFaultLocked ? lockedMessage() : ((faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity ? lockedCountExceeded2(this.maxCountFaultsNewActivity) : '') }}"
          [iconName]="'_flag-2'"></mydocma-custom-mat-icon>
        {{  'MM.general.button.shortcuts' | translate }}
      </button>

      <mat-menu #shortcutMenu="matMenu">
        <button class="mat-menu-item" *ngFor="let sc of (permissionService.shortcuts$ | async)"
                (click)="addActivitiesByShortcut($event, sc)"
                [disabled]="(permissionService.permissionNewActivity$ | async) === false || (faultsState$ | async).IsAnyFaultLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity">
          <mydocma-custom-mat-icon [iconName]="IconName(sc)"></mydocma-custom-mat-icon>
          {{ sc.Status.Name1 + (sc.Status.Name2 ? ' - ' + sc.Status.Name2 : '') }}
        </button>
        <button class="mat-menu-item"
                matTooltip="{{'MM.general.button.newActivity' | translate }}"
                [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity"
                (click)="addActivitiesByShortcut(null,null)"
                [disabled]="(permissionService.permissionNewActivity$ | async) === false || (faultsState$ | async).IsAnyFaultLocked || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity">
          <mydocma-custom-mat-icon [iconName]="'_flag-2'"></mydocma-custom-mat-icon>
          {{  'MM.general.button.newActivity' | translate }}
        </button>
      </mat-menu>


      <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || hasChanges() || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsWritings" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || hasChanges() || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsWritings" mat-menu-item (click)="writingService.startReportConfiguration(this.fault.project, [this.fault.data]);">
        <mydocma-custom-mat-icon [iconName]="'_send-letter'"
                                 matTooltip="{{'MM.general.button.writing' | translate }} {{(faultsState$ | async).IsAnyFaultLocked ? lockedMessage() : ((faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsWritings ? lockedCountExceeded2(this.maxCountFaultsWritings) : '') }}"></mydocma-custom-mat-icon>
        {{'MM.general.button.writing' | translate }}
      </button>
      <button [disabled]="hasChanges()"[class.disabled-button]="hasChanges() || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsReports" mat-menu-item (click)="reportService.startReportConfiguration(this.fault.project, [this.fault.data]);">
        <mydocma-custom-mat-icon fontSet="material-icons-outlined"
                                 matTooltip="{{'MM.reporting.report' | translate }} {{((faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsReports ? lockedCountExceeded2(this.maxCountFaultsReports) : '') }}"
                                 [iconName]="'description'"></mydocma-custom-mat-icon>
        {{'MM.reporting.report' | translate }}
      </button>
      <!--      <button [disabled]="hasChanges()" mat-menu-item>-->
      <!--        <mydocma-custom-mat-icon [iconName]="'_graph-report'"></mydocma-custom-mat-icon>-->
      <!--        {{'MM.general.button.report' | translate}}-->
      <!--      </button>-->
      <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || (rightPaneService.isUndocked$ | async)" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || (rightPaneService.isUndocked$ | async)" *ngIf="fault?.pin && (permissionAddAttachment$ | async)" mat-menu-item
              (click)="faultActionsService.onPlanClipping(this.fault, this)">
        <mydocma-custom-mat-icon [iconName]="'_plan_modell_section'"></mydocma-custom-mat-icon>
        {{'MM.general.button.addPlanSection' | translate}}
      </button>
      <!--      <button [disabled]="hasChanges()" (click)="onSyncClick()" mat-menu-item>-->
      <!--        <mydocma-custom-mat-icon [iconName]="'_synchronize'"></mydocma-custom-mat-icon>-->
      <!--        {{'MM.general.button.synchronize' | translate }}-->
      <!--      </button>-->

      <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || hasChanges()" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || hasChanges()" *ngIf="!fault?.pin" (click)="faultActionsService.onLocatePinOnPlan(this.fault, this);" mat-menu-item>
        <mydocma-custom-mat-icon [iconName]="'_plan-view'"></mydocma-custom-mat-icon>
        {{'MM.general.button.locateOnPlan' | translate }}
      </button>

      <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || hasChanges() || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || hasChanges() || (faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity" *ngIf="permissionDelete$ | async" mat-menu-item (click)="faultActionsService.onDeleteClick([this.fault])">
        <mydocma-custom-mat-icon [iconName]="'_delete'"
                                 matTooltip="{{'MM.general.button.delete' | translate }} {{(faultsState$ | async).IsAnyFaultLocked ? lockedMessage() : ((faultsState$ | async).SelectedFaultsCount > this.maxCountFaultsNewActivity ? lockedCountExceeded2(this.maxCountFaultsNewActivity) : '') }}"></mydocma-custom-mat-icon>
        {{'MM.general.button.delete' | translate }}
      </button>
      <button [disabled]="(faultsState$ | async).IsAnyFaultLocked || hasChanges()" [class.disabled-button]="(faultsState$ | async).IsAnyFaultLocked || hasChanges()"
              *ngIf="fault?.pin && (permissionDeletePins$ | async) && (((faultsSplitService.rightViewVisible$ | async) || deviceService.isMobil()) || isPaneUndocked)"
              mat-menu-item (click)="onDeletePin()">
        <mydocma-custom-mat-icon [iconName]="'_pin-delete'"></mydocma-custom-mat-icon>
        {{'MM.plan.removePin' | translate }}
      </button>

      <button mat-menu-item (click)="onOpenFieldConfiguration()"
              [disabled]="(changeService.changesPerMask.get(faultRightPane) | async)">
        <mydocma-custom-mat-icon [iconName]="'settings'"></mydocma-custom-mat-icon>
        {{'MM.general.button.field-settings' | translate }}

      </button>
    </mat-menu>
  </div>
</mydocma-mm-app-pane-header>

<div class="pane-body" mydocmaResizeEvent (resize)="onResize($event)">
  <mydocma-loader *ngIf="(mmFaultDetailsService.onFaultLoading | async)
                          || (faultsViewService.loadingState | async)
                          || (faultViewService.faultLoading$ | async)
                          || (fault?.loadState?.status === loadStatus.Loading)
                          || (triggerLoader$ | async)
                          || (faultFieldMemoryService.memoryValuesLoading$ | async)
                          || (rightPaneService.saving$ | async)
                          || (fieldConfigurationService.loading$ | async)" class="mydocma-mm-loader">
  </mydocma-loader>
  <!--  <mydocma-loader *ngIf="(faultViewService.faultLoading$ | async)" class="mydocma-mm-loader"></mydocma-loader>-->

  <mat-tab-group
    (selectedIndexChange)="fabButtonService.currentRightPaneTabIndex = $event"
    #tabGroup style="height: 100%;" [(selectedIndex)]="tabIndex" animationDuration="0ms" class="mydocma-tab-group">
    <mat-tab #firstTab>
      <ng-template mat-tab-label>
        <mat-icon>format_align_left</mat-icon>
        <span *ngIf="showTabTexts">Details</span>
        <sup *ngIf="faultFormValid == false && showTabTexts" style="margin-bottom: 10px; color:red;">*</sup>
      </ng-template>

      <div class="tab-container">
        <mydocma-mm-fault-detail-form #detailForm
                                      (onFormReady)="onFormReady($event)"
                                      (faultFormValidEvent)="setFormState($event)" [faultItem]="fault"
                                      [isLocked]="isLocked">
        </mydocma-mm-fault-detail-form>
      </div>
    </mat-tab>

    <mat-tab #secondTab>
      <ng-template mat-tab-label>
        <mat-icon>outlined_flag</mat-icon>
        <span *ngIf="showTabTexts">{{'MM.activity.activities' | translate }}</span>
      </ng-template>

      <ng-template matTabContent>
        <div class="tab-container">
          <mydocma-mm-fault-activities [fault]="fault" [isLocked]="isLocked">
          </mydocma-mm-fault-activities>
        </div>
      </ng-template>
    </mat-tab>


    <mat-tab #thirdTab>
      <ng-template mat-tab-label>
        <mat-icon>attach_file</mat-icon>
        <span *ngIf="showTabTexts">{{'MM.attachment.attachments' | translate }}</span>
      </ng-template>

      <ng-template matTabContent>
        <div class="tab-container">
          <div>
            <mydocma-top-actions class="mydocma-mm-at-top-actions top-actions mydocma-mm-actions-bar"
                                 *ngIf="(permissionAddAttachment$ | async)">
              <div #ref actions-bar-content>
                <mydocma-new-fab
                  class="mydocma-mm-action-new"
                  [button]="fabButton"
                  (itemClick)="newAttachmentFromFile()">
                </mydocma-new-fab>
              </div>
            </mydocma-top-actions>
            <div class="attachments-list">
              <mydocma-mm-fault-attachments [fault]="fault">
              </mydocma-mm-fault-attachments>
            </div>
          </div>
        </div>

      </ng-template>
    </mat-tab>
  </mat-tab-group>

</div>
<div
  class="mobile-pane-footer"
  *ngIf="
  ((appContainerService.mobileView$ | async) && !fmFaultsFabButtonService.currentRightPaneTabIndex)
   || isPaneUndocked">
  <div style="margin-right: 16px">
    <button mat-stroked-button class="mydocma-btn" [class.dv-back-button]="(this.planEditService.planEditMode === planEditModeEnum.Edit)" (click)="onCloseOrBackClick()" [disabled]="(rightPaneService.saving$ | async)">
      <mat-icon *ngIf="this.planEditService.planEditMode === planEditModeEnum.Edit">chevron_left</mat-icon>
      {{ (this.planEditService.planEditMode === planEditModeEnum.Edit)
        ? ('MM.general.button.back' | translate)
        : (((rightPaneService.saving$ | async) || !(((changeService.changesPerMask.get(faultRightPane) | async) || (changeService.changesPerMask.get(planRightPane) | async))))
          ? ('MM.general.button.close' | translate)
          : ('MM.general.button.cancel' | translate))
      }}
    </button>
  </div>
  <div>
    <button mat-stroked-button class="mydocma-btn-primary" (click)="onDoneClick()"
          [disabled]="(rightPaneService.saving$ | async) || !(((changeService.changesPerMask.get(faultRightPane) | async) || (changeService.changesPerMask.get(planRightPane) | async)) && !(((plansManagerService.selectedPlan$ | async) == null) && (planEditService.planEditMode$ | async) === 3))">
          <mat-icon>done</mat-icon>
          {{'MM.general.button.save' | translate}}
    </button>
  </div>
</div>

